import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ffc107",
        secondary: "#673ab7",
        accent: "#ff9800",
        error: "#ff5722",
        warning: "#ffeb3b",
        info: "#00bcd4",
        success: "#8bc34a"
      }
    },
  },
});
